const getAlertBannerOffset = (
	showTop: boolean | undefined,
	showBottom: boolean | undefined,
	bothValue: string,
	oneValue: string
): string | undefined => {
	if (showTop && showBottom) return bothValue;
	if (showTop || showBottom) return oneValue;
	return undefined;
};

const calculateMinHeight = (
	showMobileHeaderLocationBar: boolean | null | undefined,
	baseXs: string,
	baseMd: string,
	additionalXs?: string,
	additionalMd?: string
) => {
	const xsBase = showMobileHeaderLocationBar ? baseXs : '4rem';
	return {
		xs: additionalXs ? `calc(${xsBase} + ${additionalXs})` : xsBase,
		md: additionalMd ? `calc(${baseMd} + ${additionalMd})` : baseMd,
	};
};

export const getMinHeaderHeightStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	isWithNavMenu?: boolean,
	showHeaderWithLocationNav?: boolean,
	showTopAlertBannerMessagesMobile?: boolean,
	showBottomAlertBannerMessagesMobile?: boolean,
	showTopAlertBannerMessagesDesktop?: boolean,
	showBottomAlertBannerMessagesDesktop?: boolean
) => {
	if (isWithNavMenu) {
		const baseXs = '6rem';
		const baseMd = '8.5rem';

		const additionalXs = getAlertBannerOffset(showTopAlertBannerMessagesMobile, showBottomAlertBannerMessagesMobile, '5.5rem', '2.75rem');
		const additionalMd = getAlertBannerOffset(showTopAlertBannerMessagesDesktop, showBottomAlertBannerMessagesDesktop, '6rem', '3rem');

		return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseXs, baseMd, additionalXs, additionalMd) };
	}

	if (showHeaderWithLocationNav) {
		const baseLocXs = '7.25rem';
		const baseLocMd = '8.75rem';

		const additionalXs = getAlertBannerOffset(showTopAlertBannerMessagesMobile, showBottomAlertBannerMessagesMobile, '5.8rem', '2.825rem');
		const additionalMd = getAlertBannerOffset(showTopAlertBannerMessagesDesktop, showBottomAlertBannerMessagesDesktop, '5.8rem', '2.825rem');

		return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseLocXs, baseLocMd, additionalXs, additionalMd) };
	}

	return { minHeight: calculateMinHeight(showMobileHeaderLocationBar, '6rem', '6.875rem') };
};

export const getHeaderWrapperStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	isWithNavMenu?: boolean,
	showHeaderWithLocationNav?: boolean,
	showTopAlertBannerMessagesMobile?: boolean,
	showBottomAlertBannerMessagesMobile?: boolean,
	showTopAlertBannerMessagesDesktop?: boolean,
	showBottomAlertBannerMessagesDesktop?: boolean
) => ({
	width: '100vw',
	...getMinHeaderHeightStyles(
		showMobileHeaderLocationBar,
		isWithNavMenu,
		showHeaderWithLocationNav,
		showTopAlertBannerMessagesMobile,
		showBottomAlertBannerMessagesMobile,
		showTopAlertBannerMessagesDesktop,
		showBottomAlertBannerMessagesDesktop
	),
	backgroundColor: 'backgrounds.white',
});
